module.exports = __webpack_public_path__ + "static/netsafe-logo-2c11e75e4a45ccdc516570e05f0fec3d.png";